import { Module } from '../Module';
import { GetLocalesRequest } from '../ServerApi/requests/GetLocalesRequest';
import { ILocale } from '../ServerApi/types/ILocale';
import { ServerService } from '../services/ServerService';

export class Locales {

  public static $inject = ['$translate', 'ServerService'];

  constructor(private $translate: ng.translate.ITranslateService, private server: ServerService) {}

  public getAll(): ng.IPromise<ILocale[]> {
    return this.server.sendRequest(new GetLocalesRequest()).then(result => result.locales);
  }

  // a special value for the user locale that indicates that we should use the server locale
  public unspecifiedLocale(): ILocale {
    return {
      displayName: this.$translate.instant('unspecified'),
      locale: null
    };
  }

}

Module.instance().service('Locales', Locales);
